angular
    .module('dashboard')
    .component('brandOrders',
        {
            template: '<div><div ui-view="orderview"></div></div>'
        });